import helper from 'store/actions/actionHelper';
import { remindService } from 'modules/assistant/services';

export const addQuestionnaireReminder = (date, id, actionOptions?: any) => {
  return helper.dispatchAsyncAction(async () => {
    await remindService.addQuestionnaireReminder({ date, id });
  }, actionOptions);
};
